/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Additional planning settings.
 */
export interface DeliverySettingsDelivery { 
    /**
     * Restrict to drive to a warehouse in the middle of the trip - always start or finish the trip at a warehouse.
     */
    restrict_middle_warehouses?: boolean;
    /**
     * Restrict to drive to more than one warehouse during the trip. It is possible only if all orders have the same warehouse. If one of orders has more than one warehouse and this option is enabled, the validation will show an error. 
     */
    restrict_multiple_warehouses?: boolean;
    /**
     * Restrict to deliver both `PICKUP` and `DROP` in the same trip. 
     */
    restrict_multiple_order_types?: boolean;
}

